// extracted by css-extract-rspack-plugin
export default {"limitBarContainer":"tTrxiYqx","row":"U9dWvr7l","progressBarBlock":"zh_gFUn2","progressBarLine":"KrTWzHWZ","animateLimits":"u6fWyC6X","errorBackgroundColor":"S7k3R65O"};